export var isCardFixed = function (item) {
    var cardTypes = [
        "Video",
        "Article",
        "Participate",
        "Interactive",
        "Contest",
        "BasicPage",
        "Program",
    ];
    return cardTypes.includes(item.type) || item.__typename === "Ticket";
};
